import { RouterHandlerInterface } from "./types/routeHandler.interface"

export class ClubSlugHandler implements RouterHandlerInterface {
    private clubUrlPattern = /(?:.+)\/(?:[\w-]+)\/club\/([^\/]+)/i

    getRoute(): string {
        return `rest/public/v1/memberships/${this.getBrandSlug()}/login`
    }

    private getUrlParams(url = window.location.search): any {
        return new Proxy(new URLSearchParams(url), {
            get: (searchParams, prop: string) => searchParams.get(prop)
        })
    }

    private getSlug(url): string | undefined {
        const { 1: slug } = url?.match(this.clubUrlPattern) || []
        return slug
    }

    getBrandSlug(): string | undefined {
        const url = this.getUrlParams()

        let brandSlug = this.getSlug(url.redirect_uri)
        if (brandSlug) return brandSlug

        brandSlug = this.getSlug(url.service)
        if (brandSlug) return brandSlug

        const service = this.getUrlParams(decodeURIComponent(url.service))
        brandSlug = this.getSlug(service.redirect_uri)

        return brandSlug
    }
}
